import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools/src/index.tsx';
import { defaultState } from '../default-state.tsx';
import rootEpic from '../epics/index.tsx';
import rootReducer from '../reducers/index.tsx';

const createStore1 = (initialState = defaultState) =>
	createStore(
		rootReducer,
		initialState,
		composeWithDevtools({ name: 'SingleBoardFrame' })(
			applyMiddleware(createEpicMiddleware(rootEpic)),
		),
	);

export default createStore1;
